import linkObfuscation from 'assets/core/js/module/seoLink'

document.addEventListener('DOMContentLoaded', () => {
  linkObfuscation()
})
